import React from "react";
import PropTypes from "prop-types";
import Modal from "../../Modal";
import FormField from "../../FormUi/FormField";
import FormSelect from "../../FormUi/FormSelect";
import { createConsumer } from "@rails/actioncable";
import axios from "axios";
import classNames from "classnames";

import Messages from "./Messages";
import SendMessage from "./SendMessage";
import ChatroomFormModal from "../ChatroomFormModal"

class Chatroom extends React.Component {
  state = {
    messages: [],
    loading: false,
    title: this.props.chatroom.title,
    visible: false,
    errors: {},
    subscription: null,
    totalPages: 1
  };

  componentWillReceiveProps(nextProps) {
    if (this.state.subscription == null || this.props.chatroom.id !== nextProps.chatroom.id){
      this.unsubscribeFromChannel();
      const {currentUser, chatroom} = this.props;
      this.setState({
        messages: [],
        title: this.props.chatroom.title,
        loading: true,
        subscription: null
      });

      this.connection = createConsumer("/cable");

      if (this.connection.subscriptions.subscriptions.length == 0) {
        const subscription = this.connection.subscriptions.create({
          channel: "ChatroomChannel",
          room_id: nextProps.chatroom.id
        }, {
          connected: () => {
            this.loadMessages();
          },
          disconnected: () => {
            this.setState({loading: true});
          },
          received: (message) => {
            if (message.user.id !== currentUser.id) {
              const messages = this.state.messages;
              if (!messages.some(prevMessage => message.id === prevMessage.id)) {
                messages.push(message);
              };
              this.buildMessages(messages);
            }
          }
        });

        this.setState({subscription: subscription});
      };
    };
  };

  render() {
    const {messages, loading} = this.state;
    const {chatroom} = this.props;

    return (
      <div className="chatrooms-chat">
        <div className="container">
          <div className="chatroom-header">
            {chatroom.title}

            {(this.canUpdateChatroom() && this.chatroomIsActive()) && (
              <div className="pull-right">
                <span
                  className="material-icons icon-in-row pointer-hand"
                  onClick={this.handlerToggleModal}
                  tabIndex={0}
                  onKeyDown={(e) => e.key === "Enter" && this.handlerToggleModal()}
                >
                  edit
                </span>
                <span
                  className="material-icons icon-in-row pointer-hand"
                  onClick={this.archiveChatroom}
                  tabIndex={0}
                  onKeyDown={(e) => e.key === "Enter" && this.archiveChatroom()}
                >
                  archive
                </span>
              </div>
            )}
            {(this.canUpdateChatroom() && this.chatroomIsArchived() && this.chatroomIsRestorable()) && (
              <div className="pull-right">
                <span
                  className="material-icons icon-in-row pointer-hand"
                  onClick={this.restoreChatroom}
                  tabIndex={0}
                  onKeyDown={(e) => e.key === "Enter" && this.restoreChatroom()}
                >
                  restore_from_trash
                </span>
              </div>
            )}
            {this.chatroomIsNotRestorable() && (
              <div className="pull-right">
                <span
                  className="material-icons icon-in-row not-allowed pink-text"
                  title="This chatroom cannot be restored, please restore the Location/Position"
                >
                  restore_from_trash
                </span>
              </div>
            )}
          </div>
          <ChatroomFormModal
            key={this.props.chatroom.id}
            visible={this.state.visible}
            currentUser={this.props.currentUser}
            chatroom={this.props.chatroom}
            chatroomTypes={this.props.chatroomTypes}
            addChatroom={this.props.addChatroom}
            handlerToggleModal={this.handlerToggleModal}
            selectedChatroomUsers={this.props.selectedChatroomUsers}
            title={"Edit Chat"}
            updateChatroom={this.props.updateChatroom}
            newChatroom={false}
            userOptions={this.props.userOptions}
            locationId={this.props.locationId}
            positionId={this.props.positionId}
          />
          { loading ? (
            <center>
              <br />
              <p className="grey-text">Loading...</p>
              <br />
              <div className="load-wrapp">
                <div className="load-9">
                  <div className="spinner">
                    <div className="bubble-1" />
                    <div className="bubble-2" />
                  </div>
                </div>
              </div>
            </center>
          ) : (
            <Messages messages={messages}/>
          )}
          {this.chatroomIsActive() && (
            <>
              {(this.currentUserIsMember() && this.currentUserCanSendMessage()) &&
                <SendMessage
                  chatroomId={chatroom.id}
                  onSent={this.handlerAdd}
                  loading={this.state.loading}
                />
              }
              {(!this.currentUserIsMember() && this.currentUserCanSendMessage()) &&
                <div className="sender-box">
                  <div className="pink-text center-text">
                    You are not a member of this chat, if you would like to send messages please join the chat below.
                  </div>
                  <a
                    className="btn btn-pink btn-block btn-raised"
                    disabled={this.props.loading}
                    onClick={this.joinChatroom}
                    tabIndex={0}
                    onKeyDown={(e) => e.key === "Enter" && this.joinChatroom()}
                  >
                    JOIN CHAT
                  </a>
                </div>
              }
              {(!this.currentUserCanSendMessage()) &&
                <div className="sender-box">
                  <div className="pink-text center-text">
                    Messaging is disabled for this chat.
                  </div>
                </div>
              }
            </>
          )}
        </div>
      </div>
    );
  }

  chatroomIsActive = () => {
    return this.props.chatroom.active == true
  };

  chatroomIsArchived = () => {
    return this.props.chatroom.active != true
  };

  chatroomIsRestorable = () => {
    return this.props.chatroom.restorable == true
  }

  chatroomIsNotRestorable = () => {
    return this.props.chatroom.restorable != true
  }

  chatroomRepliesEnabledForNonAdmin = () => {
    return this.props.chatroom.replies_enabled_for_non_admin == true
  }

  currentUserCanSendMessage = () => {
    return this.chatroomRepliesEnabledForNonAdmin() || this.canUpdateChatroom()
  }

  currentUserIsMember = () => {
    return this.props.selectedChatroomUsers.filter(
      (user) => user.user_id == this.props.currentUser.id
    ).length > 0
  };

  unsubscribeFromChannel = () => {
    if (this.state.subscription) {
      this.state.subscription.unsubscribe();
    };
  };

  handlerToggleModal = () => this.setState({visible: !this.state.visible});

  canUpdateChatroom = () => { return this.props.currentUser.admin == true }

  loadMessages = () => {
    const {currentUser, chatroom} = this.props;
    axios.get(`/chatrooms/${chatroom.id}/messages`)
      .then(({data}) => {
        this.buildMessages(data.messages.reverse());
        this.setState({ totalPages: data.total_pages });
      })
    ;
  };

  handlerAdd = (message) => {
    const messages = this.state.messages;
    messages.push(message);
    this.buildMessages(messages);
  };

  buildMessages = (messages) => {
    const {currentUser} = this.props;
    const built_messages = messages.map((message) => {
      message.direction = (currentUser.id === message.user.id ? "outgoing" : "incoming");
      return message;
    });
    this.setState({loading: false});
    this.setState({messages: built_messages}, () => {
      this.moveScroll();
    });
    this.updateReadStatusAndLastAccessed();
  };

  moveScroll = () => {
    const messagesBox = window.document.getElementById("messagesBox");
    if (!messagesBox) { return; }

    messagesBox.scrollTo(0, messagesBox.scrollHeight);
  };

  updateReadStatusAndLastAccessed = () => {
    axios.put(`/chatrooms/${this.props.chatroom.id}/mark_read`)
  };

  archiveChatroom = () => {
    if (
      confirm(
        "Are you sure you want to archive this chat?"
      ) == true
    ) {
      if(this.state.loading) { return; }
      this.setState({loading: true});

      axios.delete(
        `/chatrooms/${this.props.chatroom.id}`, {}
      ).then(({data}) => {
        this.setState({loading: false});
        this.props.removeChatroom(this.props.chatroom);
        toastr.success("Chat Archived");
      }).catch(({response}) => {
        this.setState({loading: false});
        toastr.error(response.data.errors);
      });
    };
  };

  restoreChatroom = () => {
    if (
      confirm(
        "Are you sure you want to restore this chat?"
      ) == true
    ) {
      if(this.state.loading) { return; }
      this.setState({loading: true});

      axios.put(
        `/chatrooms/${this.props.chatroom.id}/restore`, {}
      ).then(({data}) => {
        this.setState({loading: false});
        this.props.removeChatroom(this.props.chatroom);
        toastr.success("Chat Restored");
      }).catch(({response}) => {
        this.setState({loading: false});
        toastr.error(response.data.errors);
      });
    };
  };

  joinChatroom = () => {
    if(this.state.loading) { return; }
    this.setState({loading: true});

    axios.put(
      `/chatrooms/${this.props.chatroom.id}/join?user_id=${this.props.currentUser.id}`, {}
    ).then(({data}) => {
      this.setState({loading: false});
      this.props.updateChatroom(data);
      toastr.success("Chat Joined");
    }).catch(({response}) => {
      this.setState({loading: false});
      toastr.error(response.data.errors);
    });
  }
}

Chatroom.propTypes = {
  currentUser: PropTypes.object.isRequired,
  chatroom: PropTypes.object.isRequired,
  users: PropTypes.array,
  removeChatroom: PropTypes.func,
  updateChatroom: PropTypes.func,
};

export default Chatroom;
